"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
function MemberLabel({ isInvitePending, name }) {
    return ((0, jsx_runtime_1.jsxs)(LabelContainer, { "data-e2e": 'MemberLabel_LabelContainer', children: [(0, jsx_runtime_1.jsx)(Name, { "data-e2e": 'MemberLabel_Name', children: name }), isInvitePending && ((0, jsx_runtime_1.jsx)(PendingInviteLabel, { "data-e2e": 'MemberLabel_PendingInviteLabel', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.invitePending) }))] }));
}
exports.default = MemberLabel;
const LabelContainer = styled_components_1.default.div `
  margin: auto auto auto 0;
  display: flex;
  flex-direction: column;
`;
const Name = styled_components_1.default.div `
  color: ${props => props.theme.text};

  font-weight: bold;
  font-size: 12px;
`;
const PendingInviteLabel = styled_components_1.default.div `
  color: #9b9ea1; // color is missing in the theme colors
  font-size: 12px;
  opacity: 0.5;
`;
